import { SVGProps } from 'react';

const Theater = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 15c0-3-2-5-2-5s3-3 3-8m-3 8c4.4 0 8-3.6 8-8m10 13c0-3 2-5 2-5s-3-3-3-8m3 8c-4.4 0-8-3.6-8-8M8 15h8M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1m4 0v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1"
    />
  </svg>
);
export default Theater;
